import { theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe, pxToRem } from '@noths/polaris-client-styles';
import type { RuleSet } from 'styled-components';
import { css, keyframes } from 'styled-components';

import type { SpinnerColorMode, SpinnerSize } from './types';

const { fonts, responsiveText } = theme;

const spinnerAnimation = keyframes`
  0% {
    clip-path:polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    transform: rotate(0deg);
  }
  12.5% {
    clip-path:polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    transform: rotate(45deg);
  }
  25% {
    clip-path:polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    transform: rotate(90deg);
  }
  37.5% {
    clip-path:polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    transform: rotate(135deg);
  }
  50% {
    clip-path:polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    transform: rotate(180deg);
  }
  62.5% {
    clip-path:polygon(50% 50%, 100% 0, 100% 0, 100% 100%, 0 100%, 0 0);
    transform: rotate(225deg);
  }
  75% {
    clip-path:polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 0 100%, 0 0);
    transform: rotate(270deg);
  }
  87.5% {
    clip-path:polygon(50% 50%, 0 100%, 0 100%, 0 100%, 0 100%, 0 0);
    transform: rotate(315deg);
  }
  100% {
    clip-path:polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    transform: rotate(360deg);
  }
`;

export const loadingWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const loadingMessage = css`
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveText.HEADING.SM};
`;

export const spinner = css`
  border-radius: 50%;
  position: relative;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    box-sizing: border-box;
    inset: ${pxToRem(-4)};
    border-radius: 50%;
    animation: ${applyKeyframe(spinnerAnimation)} 1.5s infinite linear;
  }
`;

export const spinnerColor: Record<SpinnerColorMode, RuleSet<object>> = {
  light: css`
    border: ${pxToRem(4)} solid var(--brand-purple-30);

    &::before {
      border: ${pxToRem(4)} solid var(--brand-purple-base);
    }
  `,
  dark: css`
    border: ${pxToRem(4)} solid var(--neutral-white-base);

    &::before {
      border: ${pxToRem(4)} solid var(--neutral-black-base);
    }
  `,
};

export const spinnerSize: Record<SpinnerSize, RuleSet<object>> = {
  small: css`
    height: ${pxToRem(24)};
    width: ${pxToRem(24)};
  `,
  medium: css`
    height: ${pxToRem(32)};
    width: ${pxToRem(32)};
  `,
  large: css`
    height: ${pxToRem(64)};
    width: ${pxToRem(64)};
  `,
};
